<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-6 my-2 rounded rounded-3" style=" background-color: #f7f7f7;">
        <ul class="nav nav-pills nav-justified rounded rounded-3" id="ex1">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="pesan-pesawat"
              data-bs-toggle="tab"
              href="#form-pesan-pesawat"
              role="tab"
              data-bs-placement="right"
              title="Pesawat"
              aria-controls="tab-pesan-pesawat"
              aria-selected="true"
              >
                <i class="fas fa-plane text-primary"></i>
                <span class="d-block text-secondary" style="font-size: 0.75rem;">Pesawat</span>
              </a>
          </li>
          <!-- <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="pesan-pesawat-internasional"
              data-bs-toggle="tab"
              href="#form-pesan-pesawat-internasional"
              role="tab"
              data-bs-placement="right"
              title="Pesawat Internasional"
              aria-controls="tab-pesan-pesawat-internasional"
              aria-selected="true"
              ><i class="fas fa-plane-departure text-success"></i></a
            >
          </li> -->
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="pesan-kereta-api"
              data-bs-toggle="tab"
              data-bs-placement="right"
              title="Kereta Api"
              href="#form-pesan-kereta-api"
              role="tab"
              aria-controls="tab-kereta-api"
              aria-selected="false"
              >
                <i class="fas fa-train text-warning"></i>
                <span class="d-block text-secondary" style="font-size: 0.75rem;">Kereta Api</span>
              </a>
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="pesan-pelni"
              data-bs-toggle="tab"
              href="#form-pesan-pelni"
              role="tab"
              data-bs-placement="right"
              title="Pelni"
              aria-controls="tab-pelni"
              aria-selected="false"
              >
                <i class="fas fa-ship text-primary-emphasis"></i>
                <span class="d-block text-secondary" style="font-size: 0.75rem;">Pelni</span>
              </a>
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="pesan-hotel"
              data-bs-toggle="tab"
              href="#form-pesan-hotel"
              role="tab"
              data-bs-placement="right"
              title="Hotel"
              aria-controls="tab-hotel"
              aria-selected="false"
              >
                <i class="fas fa-hotel text-danger"></i>
                <span class="d-block text-secondary" style="font-size: 0.75rem;">Hotel</span>
              </a>
          </li>
          <li class="nav-item" role="presentation">
            <NuxtLink
              class="nav-link"
              id="pesan-ppob"
              to="/ppob"
              data-bs-placement="right"
              title="Pulsa dan Tagihan"
              aria-controls="tab-ppob"
              aria-selected="false"
              >
                <i class="fas fa-money-bills text-success-emphasis"></i>
                <span class="d-block text-secondary" style="font-size: 0.75rem;">Pulsa Tagihan</span>
              </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-link.active {
  background-color: #114777;
  color: white !important;
}

.nav-link.active i {
  color: white !important;
}

.nav-link.active span {
  color: white !important;
}

/* .nav-link {
  border: transparent;
  background-color: #f7f7f7;
} */
</style>
